import React from 'react';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import {Link} from 'react-router';
import {terminateSubscription} from '../../actions/SubscriptionActions';
import moment from 'moment';
import {withStyles} from '@material-ui/core/styles';
/**
 * Alerts are urgent interruptions, requiring acknowledgement, that inform the user about a situation.
 */
 const styles = theme => ({
  button: {
    color: "white",
    textTransform: "initial",

  },
  margin: {

      margin: "1em 17em",
    }

});

class TerminationSubDialog extends React.Component {
  state = {
    open: false,
    openRedirect: false,
    confimResilation: false,
  };

  handleOpen = () => {
    const { terminationReason, value } = this.props;
    const { applyReimbursment } = !!terminationReason && terminationReason.find(reason => value === reason.code) || {}
    if (applyReimbursment) {
      this.setState({ openRedirect: true });
    } else {
      this.setState({ open: true });
    }
  };


  handleClose = () => {
    this.setState({open: false });
  };


handleConfirm = (event) => {
  event && event.preventDefault();
  const { dispatch } = this.props
  // const date = moment(new Date().getTime()).format("YYYY-MM-DD");
  // subscription.cancel_reason = this.props.value;
  // subscription.termination_date = date;
  dispatch(terminateSubscription(subscription));
  this.setState({ open: false, openRedirect: true });
};

  render() {
    const { messages, classes, terminationReason, value, subscription, button } = this.props;
    const { applyReimbursment } = !!terminationReason && terminationReason.find(reason => value === reason.code) || {};
    const { endAgreementDate } = subscription;
    const DateFormated = moment(endAgreementDate).format("YYYY-MM-DD")

    return (
      <div>
        {value === "" ?
          <button className="btn btn-theme-default" disabled onClick={this.handleOpen}>{button}</button>
          :
          <button className="btn btn-theme-default" onClick={this.handleOpen}>{button}</button>
        }
        <Dialog
          actionsContainerStyle={{ "text-align": "center", visibility: "" }}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
        >
          <h5 className="text-center">{messages["common.block.confirm.resiliation"].replace("XX/XX/XXXX", DateFormated)}</h5>
          <DialogActions className={classes.margin}>
            <Button onClick={this.handleClose} variant="contained" className={classes.button}>
              {messages["common.button.cancel"]}
            </Button>
            <Button onClick={this.handleConfirm} variant="contained" className={classes.button}>
              {messages["common.button.validate"]}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          actionsContainerStyle={{ "text-align": "center", visibility: "" }}
          modal={false}
          open={this.state.openRedirect}
          onRequestClose={this.handleClose}
        >
          <h5 className="text-center">{applyReimbursment ? messages["common.block.client.services"] : messages["common.block.request.taken"]}</h5>
          <DialogActions className={classes.margin}>
            <Link to={mesAbonnements_url.path}>
              <Button onClick={this.handleClose} variant="contained" className={classes.button}>
                {applyReimbursment ? messages["common.button.contact.customer.service"] : messages["common.button.return.to.subscription"]}
              </Button>
            </Link>
          </DialogActions>
        </Dialog>
      </div>
    );

  }
}
export default withStyles(styles)(TerminationSubDialog);



// WEBPACK FOOTER //
// ./src/opencell/pages/client/TerminationSubDialog.jsx